exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#seasonOneRow[data-v-69127be0]{margin-top:20px}#seasonOneRow #itemCol img[data-v-69127be0]{width:100%;box-shadow:0 0 40px -1px rgb(0 0 0/43%);border-radius:7px}#seasonOneRow #itemCol #nameP[data-v-69127be0]{text-align:center;color:#fff;font-weight:600;font-family:Architects Daughter}#itemPag[data-v-69127be0]{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69127be0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Container/SeasonOneGurus.vue
// module id = 683
// module chunks = 0